/* =====================================================================
 * Entry Point
 * ===================================================================== */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import {
  queryClient,
  hydrateFromSessionStorage,
  dehydrateToSessionStorage,
} from '@/query/client';
import { initErrorMonitoring } from '@/monitoring/sentry';
import { initPerfMetricCollector } from '@/monitoring/perfMetricCollector';
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary';
import { scheduleRuntimeFontLoading } from '@/lib/runtimeFontLoader';

/* i18n — 앱 전역 다국어 초기화 (다른 모듈보다 먼저 로드) */
import '@/i18n';

/* Temml CSS — 시스템 폰트 사용 (웹폰트 로딩 불필요, 가장 가벼움) */
import 'temml/dist/Temml-Local.css';

import { restoreCookieConsentToGA4 } from '@/hooks/useCookieConsent';

initErrorMonitoring();
initPerfMetricCollector();
restoreCookieConsentToGA4();

const scheduleQueryHydration = () => {
  const runHydration = () => hydrateFromSessionStorage();
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => {
      runHydration();
    }, { timeout: 900 });
    return;
  }
  window.setTimeout(runHydration, 0);
};

scheduleQueryHydration();
window.addEventListener('beforeunload', dehydrateToSessionStorage);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary name="root-app">
        <App />
      </AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);

scheduleRuntimeFontLoading();

